module.exports = __webpack_public_path__ + "src/img/userIcon.f9743249.svg";